import getApiUrl from "../helpers/getApiUrl";
import getEnvironment from "../helpers/getEnvironment";

const fetchFile = async (url, isToUseAuthZero = false, accessToken) => {
  const isLocalhost = !["preview", "production"].includes(getEnvironment());
  const headers: Record<string, string> = {
    "Content-Type": "application/pdf",
  };

  if (isToUseAuthZero && accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  } else if (!isToUseAuthZero && isLocalhost && process.env.token) {
    headers.Authorization = `Bearer ${process.env.token}`;
  }

  const BEResponseURL = new URL(url);
  const pdfUrl = new URL(`${process.env.apiFunctionUrl}/api/file`);
  pdfUrl.search = BEResponseURL.search;

  const response = await fetch(getApiUrl(pdfUrl.href, isToUseAuthZero), {
    method: "GET",
    headers,
    redirect: "follow",
  });

  if (response.ok) {
    const blob = await response.blob();
    var _url = window.URL.createObjectURL(blob);

    const openWindow = window.open(_url, "_blank");

    if (Boolean(openWindow)) {
      openWindow.focus();
    }
  }

  return response;
};

export default fetchFile;
